import React from 'react'
import { Navigate } from 'react-router'

class RedirectOnError extends React.Component<{ to: string, children: React.ReactNode }, { shouldRedirect?: boolean }> {

    constructor(props) {
        super(props);
        this.state = { shouldRedirect: false }
    }
    componentDidCatch(err: Error, info: { componentStack: string }) {
        this.setState({ shouldRedirect: true })
    }


    render() {
        if (this.state.shouldRedirect) {
            this.setState({ shouldRedirect: false })
            return <Navigate to={this.props.to} />
        }

        return this.props.children
    }
}

export default RedirectOnError;